"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = exports.CAP_TYPE = void 0;
const lodash_functions_1 = require("../../../../util/lodash-functions");
const default_session_1 = require("../../../../session/default-session");
const surfaces_provider_1 = require("../surfaces-provider");
exports.CAP_TYPE = 'Cap';
function Definition(params, surfaceTag) {
    let parameters;
    if ((0, lodash_functions_1.isPlainObject)(params)) {
        parameters = params;
    }
    else {
        parameters = {
            surfaceTag,
            instrumentCode: params,
        };
    }
    const { outputs, instrumentCode, extendedParams, discountingType } = parameters, instrumentDefinition = __rest(parameters, ["outputs", "instrumentCode", "extendedParams", "discountingType"]);
    const requestItem = Object.assign(Object.assign({}, instrumentDefinition), { underlyingDefinition: {
            instrumentCode,
            discountingType,
        }, underlyingType: exports.CAP_TYPE });
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const financialContracts = new surfaces_provider_1.SurfacesProvider(session);
            return financialContracts.getSurfaces([requestItem], { extendedParams, outputs });
        },
        /** @internal */
        getInstrument() {
            return requestItem;
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9zdXJmYWNlcy9jYXAvZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUVBLHdFQUFrRTtBQUNsRSx5RUFBaUU7QUFDakUsNERBQXdEO0FBRTNDLFFBQUEsUUFBUSxHQUFHLEtBQUssQ0FBQztBQUk5QixTQUFnQixVQUFVLENBQ3RCLE1BQXdDLEVBQ3hDLFVBQW1CO0lBRW5CLElBQUksVUFBbUMsQ0FBQztJQUV4QyxJQUFJLElBQUEsZ0NBQWEsRUFBQyxNQUFNLENBQUMsRUFBRSxDQUFDO1FBQ3hCLFVBQVUsR0FBRyxNQUFpQyxDQUFDO0lBQ25ELENBQUM7U0FBTSxDQUFDO1FBQ0osVUFBVSxHQUFHO1lBQ1QsVUFBVTtZQUNWLGNBQWMsRUFBRSxNQUFnQjtTQUNuQyxDQUFDO0lBQ04sQ0FBQztJQUNELE1BQU0sRUFBRSxPQUFPLEVBQUUsY0FBYyxFQUFFLGNBQWMsRUFBRSxlQUFlLEtBQThCLFVBQVUsRUFBbkMsb0JBQW9CLFVBQUssVUFBVSxFQUFsRyxrRUFBcUYsQ0FBYSxDQUFDO0lBQ3pHLE1BQU0sV0FBVyxtQ0FDVixvQkFBb0IsS0FDdkIsb0JBQW9CLEVBQUU7WUFDbEIsY0FBYztZQUNkLGVBQWU7U0FDbEIsRUFDRCxjQUFjLEVBQUUsZ0JBQVEsR0FDM0IsQ0FBQztJQUVGLE9BQU87UUFDSCxPQUFPLENBQUMsVUFBbUIsSUFBQSw0QkFBVSxHQUFFO1lBQ25DLE1BQU0sa0JBQWtCLEdBQUcsSUFBSSxvQ0FBZ0IsQ0FBQyxPQUFPLENBQUMsQ0FBQztZQUV6RCxPQUFPLGtCQUFrQixDQUFDLFdBQVcsQ0FBQyxDQUFDLFdBQVcsQ0FBQyxFQUFFLEVBQUUsY0FBYyxFQUFFLE9BQU8sRUFBRSxDQUFDLENBQUM7UUFDdEYsQ0FBQztRQUNELGdCQUFnQjtRQUNoQixhQUFhO1lBQ1QsT0FBTyxXQUFXLENBQUM7UUFDdkIsQ0FBQztLQUNKLENBQUM7QUFDTixDQUFDO0FBbkNELGdDQW1DQyJ9